var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sgc-dropdown",class:[{'open': _vm.menuState.state}],attrs:{"id":_vm.uniqueKey,"disabled":_vm.disabled},on:{"click":_vm.changeState}},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }